// Pure selector returning the active vault's display name. Reads
// from `useMasterSession.master.appConfig.vaults` (the canonical
// source) rather than calling `vault.getDisplayName(handle)`. The
// vault-core `set_display_name` is still called as a secondary write
// when `VaultsTab` renames an open vault, but the UI never reads
// from that path — eliminating drift between the two stores.
//
// Returns `{ data: string | undefined }` so existing callers
// (`Sidebar.tsx`, `VaultDetailsTab.tsx`) that destructure `.data`
// keep working without touching their call sites.

import { useSession } from "../stores/session";
import { useMasterSession } from "../stores/masterSession";

export function useVaultDisplayName(): { data: string | undefined } {
  const session = useSession((s) => s.session);
  const vaults = useMasterSession((s) => s.master?.appConfig?.vaults);
  if (!session || !vaults) return { data: undefined };
  const entry = vaults.find((v) => v.id === session.vaultId);
  return { data: entry?.display_name };
}
